/*
* @描述: 订单详情
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/13 11:48
*/
<template>
    <div class="public_container">
        <div class="returnNavBar">
            <ReturnNavBar :isAllFunctions="false" :isTitleNormal="true" title="返回"></ReturnNavBar>
            <div class="returnNavBarRight">
                <i class="iconfont icon-gengduo1" @click="moreFunctionVisible = true"></i>
            </div>
        </div>
        <div class="order_info_wrap">
            <div class="flex_js_wrap mb_10">
                <div class="flex_wrap">
                    <i class="iconfont icon-a-dingdan1"></i>
                    <span class="order_num" v-text="orderDetailsData.order_num"></span>
                    <span class="handle_icon_wrap" @click="handleClickCopyOrderNum">
                        <i class="iconfont icon-fuzhi"></i>
                    </span>
                </div>
                <van-tag v-if="orderDetailsData.is_bad_debt===1"
                         color="rgba(228, 65, 68, 0.1)"
                         text-color="#E44144">坏账
                </van-tag>
            </div>
            <div class="flex_wrap">
                <div class="custom_contact_field_wrap">
                    <PersonnelCard v-if="orderDetailsData.salesperson"
                                   :userId="orderDetailsData.salesperson.value[0]">
                        <template slot="container">
                            <img :src="orderDetailsData.salesperson.text[0].avatar || defaultImg" alt=""
                                 class="avatar">
                            <span class="name" v-text="orderDetailsData.salesperson.text[0].name"></span>
                        </template>
                    </PersonnelCard>
                </div>
                <span class="line"></span>
                <i class="iconfont icon-bumenfuzeren"></i>
                <span v-if="orderDetailsData.customer_id"
                      class="company_name"
                      v-text="orderDetailsData.customer_id.text"></span>
                <span class="line"></span>
                <span class="create_date" v-text="orderDetailsData.created_at"></span>
            </div>
        </div>
        <van-tabs v-model="tabActiveName"
                  @change="handleTabActiveChange"
                  color="#2990ff"
                  title-active-color="#2990ff"
                  title-inactive-color="#666666">
            <van-tab name="detail" title="订单详情">
                <div v-loading="loading" class="detail_tab_content">
                    <CustomFormDetailMobile v-if="dataLoaded"
                                            :field_form="'orders'"
                                            :field_list="formInfoList"
                                            :form_detail="orderDetailsData"
                                            :is_edit_mode="false"
                                            :pk_id="orderDetailsData.order_id"
                                            @show-purchase-detail="handleClickShowPurchaseDetail"/>
                </div>
            </van-tab>
            <van-tab name="payment" title="款项记录">
                <div v-loading="loading" class="tab_list_wrap">
                    <div class="payments_overview_wrap">
                        <div class="flex_js_wrap mb_16">
                            <div class="page_little_title">
                                <span class="title">款项概况</span>
                            </div>
                            <el-link v-if="orderDetailsData.order_status === 1"
                                     :underline="false"
                                     icon="el-icon-plus"
                                     type="primary"
                                     @click="handleClickAddRepayment">新建回款
                            </el-link>
                        </div>
                        <div class="payments_chart_wrap flex_js_wrap">
                            <div class="left_progress_wrap">
                                <!--总回款金额 total_repay_ratio-->
                                <el-progress :percentage="receivableOrderOverviewData.total_repay_ratio"
                                             :stroke-width="8"
                                             :width="140"
                                             color="#2990FF"
                                             type="circle">
                                </el-progress>
                                <!--待回款金额 no_repay_ratio-->
                                <el-progress :percentage="receivableOrderOverviewData.no_repay_ratio"
                                             :stroke-width="8"
                                             :width="120"
                                             class="no_repay_ratio_progress"
                                             color="#F0AA32"
                                             type="circle">
                                </el-progress>
                                <!--总退款金额 total_refund_ratio-->
                                <el-progress :percentage="receivableOrderOverviewData.total_refund_ratio"
                                             :stroke-width="8"
                                             :width="100"
                                             class="total_refund_ratio_progress"
                                             color="#E44144"
                                             type="circle">
                                </el-progress>
                                <!--实际回款金额 repayment_ratio-->
                                <el-progress :percentage="receivableOrderOverviewData.repayment_ratio"
                                             :stroke-width="8"
                                             :width="80"
                                             class="repayment_ratio_progress"
                                             color="#5AB333"
                                             type="circle">
                                </el-progress>
                                <div v-if="receivableOrderOverviewData.chart_data" class="center_repay_price_wrap">
                                    <div class="label">总金额</div>
                                    <div class="amount"
                                         v-text="'¥'+receivableOrderOverviewData.chart_data.repay_price"></div>
                                </div>
                            </div>
                            <div v-if="receivableOrderOverviewData.chart_data" class="right_amount_wrap">
                                <div class="amount_item_wrap">
                                    <span class="amount_label amount_label_3">实际回款金额</span>
                                    <span class="amount_value"
                                          v-text="'¥'+receivableOrderOverviewData.chart_data.repay_price"></span>
                                </div>
                                <div class="amount_item_wrap">
                                    <span class="amount_label amount_label_1">待回款金额</span>
                                    <span class="amount_value"
                                          v-text="'¥'+receivableOrderOverviewData.chart_data.no_repay_price"></span>
                                </div>
                                <div class="amount_item_wrap">
                                    <span class="amount_label amount_label_2">总退款金额</span>
                                    <span class="amount_value"
                                          v-text="'¥'+receivableOrderOverviewData.chart_data.refund_price"></span>
                                </div>
                                <div class="amount_item_wrap">
                                    <span class="amount_label amount_label_4">总回款金额</span>
                                    <span class="amount_value"
                                          v-text="'¥'+receivableOrderOverviewData.chart_data.total_repay_price"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ul class="order_records_list brief">
                        <li v-for="row in paymentRecordList" :key="row.receivable_no" class="order_records_item">
                            <div class="order_records_heade">
                                <div class="flex_wrap">
                                    <div :class="{'link-label':row.type==='repayment'}"
                                         @click="handleClickRepaymentDetail(row)"
                                         v-text="row.type==='repayment'?row.receivable_no:row.payable_no"></div>
                                    <div class="flex_wrap">
                                        <span :class="row.type==='refund'?'payment_status_name_'+row.payment_status:'payment_status_name_'+row.status"
                                              class="status_name"
                                              v-text="row.type==='refund'?row.payment_status_name:row.status_name"></span>
                                        <span v-if="row.status===3||row.status===5"
                                              class="handle_icon_wrap"
                                              @click="handleClickShowReason(row)">
                                            <i class="iconfont icon-jinggao"></i>
                                        </span>
                                    </div>
                                </div>
                                <div>
                                    <span v-if="row.status===1&&row.uid===userInfo.user.id"
                                          class="handle_icon_wrap"
                                          @click="handleClickPaymentRevoke(row)">
                                        <i class="iconfont icon-chexiao"></i>
                                    </span>
                                    <span v-else-if="row.status===3||row.status===4||row.status===5"
                                          class="handle_icon_wrap"
                                          @click="handleClickPaymentAgain(row)">
                                    <i class="iconfont icon-zaicitijiao"></i>
                                </span>
                                </div>
                            </div>
                            <div class="order_records_content">
                                <div v-if="row.type==='repayment'" class="flex_wrap mb_8">
                                    <span class="field_label">回款公司：</span>
                                    <span class="field_value" v-text="row.payment_company_name"></span>
                                </div>
                                <div v-else class="flex_wrap mb_8">
                                    <span class="field_label">退款类型：</span>
                                    <span class="field_value" v-text="row.return_type_name"></span>
                                </div>
                                <div class="flex_js_wrap mb_8">
                                    <div class="flex_wrap">
                                        <span class="field_label">申请人：</span>
                                        <div class="custom_contact_field_wrap">
                                            <PersonnelCard v-if="row.uid_info" :userId="row.uid">
                                                <template slot="container">
                                                    <img :src="row.uid_info.avatar || defaultImg" alt=""
                                                         class="avatar">
                                                    <span class="name" v-text="row.uid_info.name"></span>
                                                </template>
                                            </PersonnelCard>
                                        </div>
                                    </div>
                                    <div class="flex_wrap">
                                        <span class="field_label"
                                              v-text="row.type==='repayment'?'回款金额：':'退款日期：'"></span>
                                        <span :class="{'refund_amount':row.type==='refund'}" class="field_value"
                                              v-text="row.payment_amount"></span>
                                    </div>
                                </div>
                                <div class="flex_wrap">
                                    <span class="field_label"
                                          v-text="row.type==='repayment'?'回款日期：':'退款日期：'"></span>
                                    <span class="field_value" v-text="row.apply_time"></span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </van-tab>
            <van-tab name="invoice" title="开票记录">
                <div v-loading="loading" class="tab_list_wrap">
                    <div class="invoice_overview_wrap">
                        <div class="flex_js_wrap">
                            <div class="page_little_title">
                                <span class="title">开票情况</span>
                            </div>
                            <el-link v-if="orderDetailsData.order_status === 1"
                                     :underline="false"
                                     icon="el-icon-plus"
                                     type="primary"
                                     @click="handleClickAddInvoice">新建开票
                            </el-link>
                        </div>
                        <div class="invoice_overview_board">
                            <div v-if="invoiceOrderOverviewData" class="flex_js_wrap percentage_wrap">
                                <el-progress :percentage="invoiceOrderOverviewData.percentage"
                                             :stroke-width="8"
                                             :width="120"
                                             color="#2990FF"
                                             type="circle">
                                </el-progress>
                                <div v-if="invoiceOrderOverviewData.percentage" class="progress_text">
                                    <div class="percentage" v-text="invoiceOrderOverviewData.percentage+'%'"></div>
                                    <div class="text">开票占比</div>
                                </div>
                                <div class="amount_wrap">
                                    <div class="flex_js_wrap" style="margin-bottom: 8px">
                                        <span class="amount_label">开票总金额</span>
                                        <span class="amount_value"
                                              v-text="'¥'+invoiceOrderOverviewData.invoice_total_amount"></span>
                                    </div>
                                    <div class="flex_js_wrap">
                                        <span class="amount_label">可开票金额</span>
                                        <span class="amount_value"
                                              v-text="'¥'+invoiceOrderOverviewData.available_invoice_amount"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ul v-infinite-scroll="scrollLoadInvoiceList" class="order_records_list brief">
                        <li v-for="row in invoiceRecoedList" :key="row.receivable_no" class="order_records_item">
                            <div class="order_records_heade">
                                <div class="flex_wrap">
                                    <div class="link-label" @click="handleClickInvoiceDetail(row)"
                                         v-text="row.invoice_no"></div>
                                    <span :class="'invoice_status_name_'+row.status" class="status_name"
                                          v-text="row.status_name"></span>
                                    <span v-if="row.status===3||row.status===4"
                                          class="handle_icon_wrap"
                                          @click="handleClickShowReason(row)">
                                        <i class="iconfont icon-jinggao"></i>
                                    </span>
                                </div>
                                <div>
                                    <span v-if="row.status===1&&row.uid===userInfo.user.id"
                                          class="handle_icon_wrap"
                                          @click="handleClickInvoiceRevoke(row)">
                                        <i class="iconfont icon-chexiao"></i>
                                    </span>
                                    <span v-else-if="row.status===3||row.status===4||row.status===5"
                                          class="handle_icon_wrap"
                                          @click="handleClickInvoiceAgain(row)">
                                    <i class="iconfont icon-zaicitijiao"></i>
                                </span>
                                </div>
                            </div>
                            <div class="order_records_content">
                                <div class="flex_wrap mb_8">
                                    <span class="field_label">开票公司：</span>
                                    <span class="field_value" v-text="row.invoice_company_name"></span>
                                </div>
                                <div class="flex_js_wrap mb_8">
                                    <div class="flex_wrap">
                                        <span class="field_label">申请人：</span>
                                        <div class="custom_contact_field_wrap">
                                            <PersonnelCard v-if="row.apply_user_info" :userId="row.uid">
                                                <template slot="container">
                                                    <img :src="row.apply_user_info.avatar || defaultImg" alt=""
                                                         class="avatar">
                                                    <span class="name" v-text="row.apply_user_info.name"></span>
                                                </template>
                                            </PersonnelCard>
                                        </div>
                                    </div>
                                    <div class="flex_wrap">
                                        <span class="field_label">开票金额：</span>
                                        <span class="field_value" v-text="row.invoice_amount"></span>
                                    </div>
                                </div>
                                <div class="flex_wrap">
                                    <span class="field_label">开票日期：</span>
                                    <span class="field_value" v-text="row.apply_time"></span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </van-tab>
            <van-tab name="outStock" title="出库记录">
                <div v-loading="loading" class="tab_list_wrap">
                    <ul v-infinite-scroll="scrollLoadOutStockList" class="order_records_list">
                        <li v-for="row in stockOutList" :key="row.id" class="order_records_item">
                            <div class="order_records_heade">
                                <span class="link-label" v-text="row.log_num"></span>
                            </div>
                            <div class="order_records_content">
                                <div class="flex_wrap mb_8">
                                    <div class="field_label">操作人：</div>
                                    <div class="field_value">
                                        <div class="custom_contact_field_wrap">
                                            <PersonnelCard :userId="row.approval_user.id">
                                                <template slot="container">
                                                    <img :src="row.approval_user.avatar || defaultImg" alt=""
                                                         class="avatar">
                                                    <span class="name" v-text="row.approval_user.name"></span>
                                                </template>
                                            </PersonnelCard>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex_wrap mb_8">
                                    <div class="field_label">操作人：</div>
                                    <div class="field_value" v-text="row.created_at"></div>
                                </div>
                                <div class="flex_wrap mb_8">
                                    <div class="field_label">备注：</div>
                                    <div class="field_value" v-text="row.note||'--'"></div>
                                </div>
                            </div>
                        </li>
                        <li v-if="stockOutList.length===0" class="ta_c p_16">暂无数据</li>
                    </ul>
                </div>
            </van-tab>
            <van-tab name="workOrder" title="关联工单">
                <div v-loading="loading" class="tab_list_wrap">
                    <ul class="order_records_list">
                        <li v-for="row in workOrderList" :key="row.id" class="order_records_item">
                            <div class="order_records_heade">
                                <div class="flex_wrap">
                                    <span class="link-label" v-text="row.workorder_num"></span>
                                    <span :class="'invoice_status_name_'+row.status" class="status_name"
                                          v-text="row.status_text"></span>
                                </div>
                            </div>
                            <div class="order_records_content">
                                <div class="flex_wrap mb_8">
                                    <div class="field_label">发布人：</div>
                                    <div class="field_value">
                                        <div v-if="row.user" class="custom_contact_field_wrap">
                                            <PersonnelCard :userId="row.user.id">
                                                <template slot="container">
                                                    <img :src="row.user.avatar || defaultImg" alt=""
                                                         class="avatar">
                                                    <span class="name" v-text="row.user.name"></span>
                                                </template>
                                            </PersonnelCard>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex_wrap mb_8">
                                    <div class="field_label">发布时间：</div>
                                    <div class="field_value" v-text="row.created_at"></div>
                                </div>
                                <div class="flex_wrap mb_8">
                                    <div class="field_label">工单实施人：</div>
                                    <div class="field_value"
                                         v-text="row.processing_users&&row.processing_users.length?row.processing_users.map(map => map.processing_user.name).join('、'):'--'"></div>
                                </div>
                            </div>
                        </li>
                        <li v-if="workOrderList.length===0" class="ta_c p_16">暂无数据</li>
                    </ul>
                </div>
            </van-tab>
            <van-tab name="afterSales" title="售后记录">
                <div v-loading="loading" class="tab_list_wrap">
                    <ul class="order_records_list">
                        <li v-for="row in afterSaleList" :key="row.order_after_sales_id" class="order_records_item">
                            <div class="order_records_heade">
                                <div class="flex_wrap">
                                    <span class="link-label" @click="handleClickAfterSaleDetail(row)"
                                          v-text="row.type_name"></span>
                                    <span :class="'approval_status_'+row.approval_status"
                                          class="status_name"
                                          v-text="row.approval_status_name"></span>
                                </div>
                                <span v-if="row.approval_status===0"
                                      class="handle_icon_wrap"
                                      @click="handleClickAfterSaleRevoke(row)">
                                    <i class="iconfont icon-chexiao"></i>
                                </span>
                            </div>
                            <div class="order_records_content">
                                <div class="flex_wrap mb_8">
                                    <div class="field_label">发布人：</div>
                                    <div class="field_value">
                                        <div class="custom_contact_field_wrap">
                                            <PersonnelCard :userId="row.uid">
                                                <template slot="container">
                                                    <img :src="row.user_avatar || defaultImg" alt=""
                                                         class="avatar">
                                                    <span class="name" v-text="row.user_name"></span>
                                                </template>
                                            </PersonnelCard>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex_wrap mb_8">
                                    <div class="field_label">售后时间：</div>
                                    <div class="field_value" v-text="row.created_at"></div>
                                </div>
                            </div>
                        </li>
                        <li v-if="afterSaleList.length===0" class="ta_c p_16">暂无数据</li>
                    </ul>
                </div>
            </van-tab>
            <van-tab name="member" title="团队成员">
                <div v-loading="loading" class="tab_list_wrap white">
                    <div v-if="orderDetailsData.order_status === 1" class="ta_r p_16">
                        <el-button icon="iconfont icon-a-shenling1"
                                   plain
                                   round
                                   size="mini"
                                   type="primary"
                                   @click="handleClickAddMember">添加成员
                        </el-button>
                    </div>
                    <ul class="team_member_list">
                        <li v-for="row in teamMemberList" :key="row.order_member_id"
                            class="team_member_item flex_js_wrap">
                            <div class="custom_contact_field_wrap">
                                <PersonnelCard :userId="row.member_uid">
                                    <template slot="container">
                                        <img :src="row.user_avatar || defaultImg" alt=""
                                             class="avatar">
                                        <span class="name" v-text="row.user_name"></span>
                                    </template>
                                </PersonnelCard>
                            </div>
                            <div class="flex_wrap">
                                <van-radio-group v-model="row.auth" direction="horizontal"
                                                 @change="handleOrderMemberAuthChange(row)">
                                    <van-radio :name="1">只读</van-radio>
                                    <van-radio :name="2">读写</van-radio>
                                </van-radio-group>
                                <span class="handle_icon_wrap" @click="handleClickRemoveMember(row)">
                                    <i class="iconfont icon-shanchu1"></i>
                                </span>
                            </div>
                        </li>
                        <li v-if="teamMemberList.length===0" class="ta_c p_16">暂无数据</li>
                    </ul>
                </div>
            </van-tab>
            <van-tab name="log" title="日志">
                <div v-loading="loading" class="tab_list_wrap">
                    <ul class="order_log_list">
                        <li v-for="item in orderLogList" :key="item.order_log_id" class="order_log_item">
                            <div class="flex_wrap">
                                <div class="custom_contact_field_wrap">
                                    <PersonnelCard :userId="item.uid">
                                        <template slot="container">
                                            <img :src="item.user_avatar || defaultImg" alt=""
                                                 class="avatar">
                                            <span class="name" v-text="item.user_name"></span>
                                        </template>
                                    </PersonnelCard>
                                </div>
                                <div class="created_at" v-text="item.created_at"></div>
                            </div>
                            <div v-if="item.content" class="log_content_wrap">
                                <div v-if="item.type ==='order_edit'">
                                    <h4>售后-订单编辑</h4>
                                    <div class="order_edit_content">
                                        <afterSaleApproveDetail :after_sales_type="item.type"
                                                                :form_detail="item.content.details"
                                                                :label_position="'left'"/>
                                    </div>
                                </div>
                                <div v-else
                                     class="log_content"
                                     v-html="item.content.details"></div>
                            </div>
                        </li>
                    </ul>
                </div>
            </van-tab>
        </van-tabs>
        <van-overlay v-if="moreFunctionVisible"
                     :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
                     :show="moreFunctionVisible"
                     z-index="1000"
                     @click="moreFunctionVisible = false">
            <div class="custom_radio_option_wrap">
                <ul class="radio_option_list">
                    <li v-if="orderDetailsData.order_status===0" class="radio_option_item"
                        @click="handleClickRevokeOrder">撤销
                    </li>
                    <li v-if="orderDetailsData.order_status===1" class="radio_option_item"
                        @click="handleClickAfterSales">订单售后
                    </li>
                    <li v-if="orderDetailsData.order_status===4" class="radio_option_item"
                        @click="handleClickEditOrder">编辑
                    </li>
                    <li v-if="orderDetailsData.order_status===2||orderDetailsData.order_status===3||orderDetailsData.order_status===4||orderDetailsData.order_status===5"
                        class="radio_option_item"
                        @click="handleClickDelOrder">删除
                    </li>
                    <li v-if="orderDetailsData.order_status===2||orderDetailsData.order_status===3||orderDetailsData.order_status===5"
                        class="radio_option_item"
                        @click="handleClickSubmitAgain">重新发起
                    </li>
                    <li v-if="orderDetailsData.order_status===0||orderDetailsData.order_status===1"
                        class="radio_option_item" @click="handleClickCopyOrder">复制订单
                    </li>
                    <li v-if="orderDetailsData.order_status===1&&Number(orderDetailsData.purchase_price)!==0"
                        class="radio_option_item" @click="handleClickAddPurchase">新增代采
                    </li>
                    <li v-if="orderDetailsData.order_status===1" class="radio_option_item"
                        @click="handleClickAddMember">添加成员
                    </li>
                    <li v-if="orderDetailsData.order_status===1" class="radio_option_item"
                        @click="handleClickCloseOrder">关闭订单
                    </li>
                    <li v-if="orderDetailsData.order_status!==4" class="radio_option_item"
                        @click="handleClickCopyOrderNum">编号复制
                    </li>
                </ul>
                <div class="cancel_btn" @click="moreFunctionVisible = false">取消</div>
            </div>
        </van-overlay>
        <RepaymentDialog v-if="repaymentDialogVisible"
                         :dialogVisible.sync="repaymentDialogVisible"
                         :order_id="orderDetailsData.order_id"
                         :receivable_no.sync="receivable_no"
                         :source="'detail'"
                         @refresh="repaymentDialogRefresh"/>
        <RepaymentDetail v-if="repaymentDetailDialogVisible"
                         :dialogVisible.sync="repaymentDetailDialogVisible"
                         :receivable_no.sync="receivable_no"/>
        <InvoiceAddDialog v-if="invoiceDialogVisible"
                          :dialogVisible.sync="invoiceDialogVisible"
                          :invoice_no.sync="invoice_no"
                          :order_id="orderDetailsData.order_num"
                          :source="'detail'"
                          @refresh="invoiceDialogRefresh"/>
        <InvoiceDetailsDialog v-if="invoiceDetailsDialogVisible"
                              :dialogVisible.sync="invoiceDetailsDialogVisible"
                              :invoice_no.sync="invoice_no"/>
        <OrderAddMember v-if="teamMembersAddVisible"
                        :dialogVisible.sync="teamMembersAddVisible"
                        :order_ids="[orderDetailsData.order_id]"
                        @refresh="getTeamMemberList"/>
        <PurchaseDetail v-if="purchaseDetailDialog"
                        :dialogVisible.sync="purchaseDetailDialog"
                        :order_amount_field="orderAmountFieldList"
                        :order_detail="orderDetailsData"
                        :order_id="orderDetailsData.order_id"
                        @refresh="refreshDetail"/>
        <OrderPurchaseAdd v-if="orderPurchaseAddVisible"
                          :dialogVisible.sync="orderPurchaseAddVisible"
                          :order_id="orderDetailsData.order_id"
                          @refresh="refreshDetail"></OrderPurchaseAdd>
        <OrderSubmitAgain v-if="submitAgainOrderDialogVisible"
                          :dialogVisible.sync="submitAgainOrderDialogVisible"
                          :order_id="orderDetailsData.order_id"
                          @refresh-list="eventBusOrderList"/>
        <OrderEdit v-if="editOrderDialogVisible"
                   :dialogVisible.sync="editOrderDialogVisible"
                   :order_id="orderDetailsData.order_id"
                   @refresh-list="refreshDetail"/>
        <OrderAfterSale v-if="orderAfterSaleDialog"
                        :dialogVisible.sync="orderAfterSaleDialog"
                        :orderInfo="orderAfterSaleInfo"
                        :order_id="orderDetailsData.order_id"
                        @order_edit="handleClickEditOrder"
                        @refresh="afterSaleDialogRefresh"/>
        <OrderAfterSaleDetail v-if="orderAfterSaleDetailDialog"
                              :after_sale_detail="orderAfterSaleDetailData"
                              :dialogVisible.sync="orderAfterSaleDetailDialog"
                              :type="after_sale_type"
                              :type_name="after_sale_type_name"/>
    </div>
</template>
<script>
import {
    invoiceOrderOverview,
    orderDetail,
    orderFundsRecordList,
    orderRepaymentRecordCancel,
    receivableOrderOverview,
    orderInvoiceSummary,
    orderInvoiceRecordCancel,
    orderDel,
    cancelApproval,
    orderClose,
    orderHasAfterSale,
    stockOutList,
    workOrderList,
    orderAfterSaleList,
    orderMemberAuthEdit,
    orderMemberList,
    orderMemberDel,
    orderLogList,
    getFormFields,
    orderAfterSaleDetail,
} from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar";
import CustomFormDetailMobile from "@/components/mComponents/CustomFormDetailMobile";
import PersonnelCard from "@/components/pComponents/PersonnelCard";
import CustomFormDetailPc from "@/components/pComponents/CustomFormDetailPc";
import {pagination} from "@/mixins";
import {mapState} from "vuex";
import {EventBus} from "@/utils/eventBus";
import {throttle} from 'lodash';
import OrderAddMember from "@/views/mobile/Order/component/add_member";
import afterSaleApproveDetail from "@/components/pComponents/afterSaleApproveDetail";
import RepaymentDialog from "./component/repayment_add"
import RepaymentDetail from "./component/repayment_detail"
import InvoiceDetailsDialog from "./component/invoice_detail";
import InvoiceAddDialog from "./component/invoice_add"
import InvoiceDialog from "@/views/pc/Order/component/invoice_dialog";
import PurchaseDetail from "./component/purchase_detail";
import OrderPurchaseAdd from "@/views/mobile/Order/component/order_purchase_add";
import OrderSubmitAgain from "@/views/mobile/Order/component/order_submit_again";
import OrderEdit from "@/views/mobile/Order/component/order_edit";
import OrderAfterSale from "@/views/mobile/Order/component/order_afte_sale";
import OrderAfterSaleDetail from "./component/order_afte_sale_detail";

export default {
    name: "OrderDetail",
    data() {
        return {
            loading: false,
            queryType: this.$route.query.query_type, // 判断详情是根据订单id还是订单编号查询，在财务页面是没有订单id的，需要根据订单编号查询
            orderDetailsData: {},
            order_id: this.$route.query.order_id,
            order_num: this.$route.query.order_num,
            moreFunctionVisible: false,
            defaultImg: require('@/assets/images/default.jpg'),
            tabActiveName: '',
            formInfoList: [],
            dataLoaded: false,
            repaymentDialogVisible: false,
            repaymentDetailDialogVisible: false,
            receivableOrderOverviewData: {},
            paymentRecordList: [],
            invoiceOrderOverviewData: {},
            invoiceRecoedList: [],
            stockOutList: [],
            workOrderList: [],
            afterSaleList: [],
            teamMembersAddVisible: false,
            teamMemberList: [],
            orderLogList: [],
            receivable_no: '',
            invoiceDialogVisible: false,
            invoiceDetailsDialogVisible: false,
            invoice_no: '',
            orderAmountFieldList: [],
            purchaseDetailDialog: false,
            orderPurchaseAddVisible: false,
            submitAgainOrderDialogVisible: false,
            editOrderDialogVisible: false,
            orderAfterSaleDialog: false,
            orderAfterSaleInfo: [],
            orderAfterSaleDetailData: {},
            orderAfterSaleDetailDialog: false,
            after_sale_type_name: '',
            after_sale_type: '',
        }
    },
    components: {
        OrderAfterSale,
        OrderEdit,
        OrderPurchaseAdd,
        InvoiceDialog,
        InvoiceAddDialog,
        InvoiceDetailsDialog,
        afterSaleApproveDetail,
        OrderAddMember,
        CustomFormDetailPc,
        PersonnelCard,
        ReturnNavBar,
        CustomFormDetailMobile,
        RepaymentDialog,
        RepaymentDetail,
        PurchaseDetail,
        OrderSubmitAgain,
        OrderAfterSaleDetail,
    },
    created() {
        this.getOrderDetail()
    },
    computed: {
        ...mapState(["userInfo"]),
    },
    mixins: [pagination],
    mounted() {

    },
    methods: {
        //点击切换tab
        handleTabActiveChange(name) {
            this.pagination.pageNum = 1
            switch (name) {
                case 'payment':
                    this.getPaymentRecordList()
                    break
                case 'invoice':
                    this.getInvoiceRecordList()
                    break
                case 'outStock':
                    this.getStockOutList()
                    break
                case 'workOrder':
                    this.getWorkOrderList()
                    break
                case 'afterSales':
                    this.getAfterSaleList()
                    break
                case 'member':
                    this.getTeamMemberList()
                    break
                case 'log':
                    this.getOrderLogList()
                    break
            }
        },

        // 获取订单详情
        getOrderDetail() {
            this.loading = true
            this.dataLoaded = false
            let params = {}
            if (this.queryType && this.queryType === 'order_num') {
                params.order_id = this.order_num
            } else {
                params.order_id = this.order_id
            }
            orderDetail(params).then(res => {
                if (res.code === 200) {
                    this.orderDetailsData = res.data
                    this.orderAfterSaleInfo = {
                        order_num: res.data.order_num,
                        customer_name: res.data.customer_id?.text
                    }
                    this.formInfoList = res.data.custom_fields
                    if (this.queryType && this.queryType === 'order_num') {
                        this.order_num = res.data.order_num
                    }
                    if (this.orderDetailsData.return_goods && this.orderDetailsData.return_goods.length > 0) {
                        this.orderDetailsData.order_goods = this.orderDetailsData.order_goods.concat(this.orderDetailsData.return_goods)
                    }
                    this.dataLoaded = true
                }
                this.loading = false
            })
        },

        // 复制订单编号
        handleClickCopyOrderNum() {
            const textarea = document.createElement('textarea');
            textarea.value = this.orderDetailsData.order_num;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            // 移除临时元素
            document.body.removeChild(textarea);
            this.$toast.success('复制成功');
        },

        //复制订单
        handleClickCopyOrder() {
            this.submitAgainOrderDialogVisible = true
        },

        //重新发起
        handleClickSubmitAgain() {
            this.submitAgainOrderDialogVisible = true
        },

        //删除订单
        handleClickDelOrder() {
            this.$dialog.confirm({
                title: '您确定要删除吗？',
                message: '删除后不可恢复，请谨慎操作！',
                confirmButtonColor: '#E44144',
            }).then(() => {
                orderDel({
                    order_id: this.orderDetailsData.order_id
                }).then(res => {
                    if (res.code === 200) {
                        this.$toast.success('删除成功！')
                        this.$router.go(-1)
                        this.refreshDetail()
                    }
                })
            }).catch(() => {
                return false
            })
        },

        // 撤销订单
        handleClickRevokeOrder() {
            this.$dialog.confirm({
                title: '确认撤销吗？',
                message: '撤销后不可恢复，请谨慎操作！',
                confirmButtonColor: '#2990FF',
            }).then(() => {
                cancelApproval({
                    approval_id: this.orderDetailsData.approval_id
                }).then(res => {
                    if (res.code === 200) {
                        this.$toast.success('撤销成功')
                        this.refreshDetail()
                    }
                })
            })
        },

        //关闭订单
        handleClickCloseOrder() {
            this.$dialog.confirm({
                title: '您确定要关闭吗？',
                message: '关闭后不可恢复，请谨慎操作！',
                confirmButtonColor: '#2990FF',
            }).then(() => {
                orderClose({
                    order_id: this.orderDetailsData.order_id
                }).then(res => {
                    if (res.code === 200) {
                        this.$toast.success('关闭成功！')
                        this.refreshDetail()
                    }
                })
            }).catch(() => {
                return false
            })
        },

        //添加代采
        handleClickAddPurchase() {
            orderHasAfterSale({
                order_id: this.orderDetailsData.order_id
            }).then(res => {
                if (res.code === 200) {
                    if (res.data.isPendingApproval) {
                        this.$toast.fail(res.data.tips)
                    } else {
                        this.orderPurchaseAddVisible = true
                    }
                }
            })
        },

        //订单售后
        handleClickAfterSales() {
            orderHasAfterSale({
                order_id: this.orderDetailsData.order_id
            }).then(res => {
                if (res.code === 200) {
                    if (res.data.isPendingApproval) {
                        this.$toast.fail(res.data.tips)
                    } else {
                        this.orderAfterSaleDialog = true
                    }
                }
            })
        },

        //编辑订单
        handleClickEditOrder() {
            this.editOrderDialogVisible = true
        },

        afterSaleDialogRefresh() {
            this.getAfterSaleList()
        },

        //查看代采明细
        handleClickShowPurchaseDetail() {
            if (this.orderAmountFieldList.length === 0) {
                getFormFields({
                    field_form: 'orders'
                }).then(res => {
                    if (res.code === 200) {
                        this.orderAmountFieldList = res.data.find(item => item.field_key === 'amount_information')._child || []
                        this.purchaseDetailDialog = true
                    }
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })
            } else {
                this.purchaseDetailDialog = true
            }
        },

        //获取款项列表
        getPaymentRecordList() {
            this.loading = true
            receivableOrderOverview({
                order_num: this.orderDetailsData.order_num
            }).then(res => {
                if (res.code === 200) {
                    this.receivableOrderOverviewData = res.data
                    const total_price = Number(this.receivableOrderOverviewData.chart_data.total_price)
                    //总回款金额比例
                    const total_repay_ratio = total_price === 0 ? 0 : Number(this.receivableOrderOverviewData.chart_data.total_repay_price) / total_price * 100
                    this.receivableOrderOverviewData.total_repay_ratio = Number(total_repay_ratio.toFixed(2))
                    //实际回款金额比例=实际回款金额/订单总金额*100%
                    const repayment_ratio = total_price === 0 ? 0 : Number(this.receivableOrderOverviewData.chart_data.repay_price) / total_price * 100
                    this.receivableOrderOverviewData.repayment_ratio = Number(repayment_ratio.toFixed(2))
                    //总退款金额比例
                    const total_refund_ratio = total_price === 0 ? 0 : Number(this.receivableOrderOverviewData.chart_data.refund_price) / total_price * 100
                    this.receivableOrderOverviewData.total_refund_ratio = Number(total_refund_ratio.toFixed(2))
                    //待回款金额比例
                    const no_repay_ratio = total_price === 0 ? 0 : Number(this.receivableOrderOverviewData.chart_data.no_repay_price) / total_price * 100
                    this.receivableOrderOverviewData.no_repay_ratio = Number(no_repay_ratio.toFixed(2))
                    orderFundsRecordList({
                        order_no: this.orderDetailsData.order_num,
                        page: 1,
                        pageSize: 100
                    }).then(res => {
                        if (res.code === 200) {
                            this.paymentRecordList = res.data
                        }
                        this.loading = false
                    })
                } else {
                    this.loading = false
                }
            })
        },

        //回款申请完成后刷新列表
        repaymentDialogRefresh() {
            this.getPaymentRecordList()
            this.getOrderDetail()
            this.eventBusOrderList()
        },

        //点击新增回款
        handleClickAddRepayment() {
            this.repaymentDialogVisible = true
        },

        //回款详情
        handleClickRepaymentDetail(row) {
            if (row.type !== 'repayment') return false
            this.receivable_no = row.receivable_no
            this.repaymentDetailDialogVisible = true
        },

        //撤销回款
        handleClickPaymentRevoke(row) {
            this.$dialog.confirm({
                title: '确定撤销当前回款记录？',
                message: '撤销后不可恢复，请谨慎操作！',
            }).then(() => {
                orderRepaymentRecordCancel({
                    receivable_no: row.receivable_no
                }).then(res => {
                    if (res.code === 200) {
                        this.$toast.success('撤销成功！')
                        this.getOrderPaymentList()
                    }
                })
            }).catch(() => {
                return false
            })
        },

        // 点击重新提交
        handleClickPaymentAgain() {

        },

        //点击弹出原因
        handleClickShowReason(row) {
            const reason = row.status === 3 ? row.reject_reason : row.invalid_reason
            this.$dialog.alert({
                title: row.status === 3 ? '驳回原因' : '作废原因',
                message: reason,
                confirmButtonColor: '#2990ff'
            }).then(() => {
                return false
            }).catch(() => {
                return false
            })
        },

        //获取开票管理列表
        getInvoiceRecordList() {
            this.loading = true
            invoiceOrderOverview({
                order_num: this.orderDetailsData.order_num
            }).then(res => {
                if (res.code === 200) {
                    this.invoiceOrderOverviewData = res.data
                    this.invoiceOrderOverviewData.percentage = Number(res.data.available_invoice_amount) === 0 ? 0 : Number((Number(res.data.invoice_total_amount) / Number(res.data.available_invoice_amount) * 100).toFixed(2))
                    orderInvoiceSummary({
                        order_no: this.orderDetailsData.order_num,
                        page: this.pagination.pageNum,
                        pageSize: this.pagination.pageSize,
                    }).then(res => {
                        if (res.code === 200) {
                            const {data, total} = res.data
                            this.invoiceRecoedList = this.invoiceRecoedList.concat(data)
                            this.pagination.total = total
                        }
                        this.loading = false
                    })
                } else {
                    this.loading = false
                }
            })
        },

        //滚动加载开票管理列表
        scrollLoadInvoiceList() {
            if (this.invoiceRecoedList.length < this.pagination.total) {
                this.pagination.pageNum++
                this.getInvoiceRecordList()
            }
        },

        //点击新增开票
        handleClickAddInvoice() {
            this.invoiceDialogVisible = true
        },

        //点击开票详情
        handleClickInvoiceDetail(row) {
            this.invoice_no = row.invoice_no
            this.invoiceDetailsDialogVisible = true
        },

        //点击重新发起开票申请
        handleClickInvoiceAgain(row) {
            this.invoice_no = row.invoice_no
            this.invoiceDialogVisible = true
        },

        //开票申请完成后刷新列表
        invoiceDialogRefresh() {
            this.getInvoiceRecordList()
            this.getOrderDetail()
        },

        //点击撤销开票申请
        handleClickInvoiceRevoke(row) {
            this.$dialog.confirm({
                title: '确定撤销当前开票记录？',
                message: '撤销后不可恢复，请谨慎操作！',
                confirmButtonColor: '#2990ff'
            }).then(() => {
                orderInvoiceRecordCancel({
                    invoice_no: row.invoice_no
                }).then(res => {
                    if (res.code === 200) {
                        this.$toast.success('撤销成功！')
                        this.getInvoiceRecordList()
                    }
                })
            }).catch(() => {
                return false
            })
        },

        //获取出库列表
        getStockOutList() {
            this.loading = true
            stockOutList({
                order_ids: [this.orderDetailsData.order_id],
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
            }).then(res => {
                if (res.code === 200) {
                    this.stockOutList = this.stockOutList.concat(res.data.list)
                }
                this.loading = false
            })
        },

        //滚动加载开票管理列表
        scrollLoadOutStockList() {
            if (this.stockOutList.length < this.pagination.total) {
                this.pagination.pageNum++
                this.getStockOutList()
            }
        },

        //获取关联工单订单
        getWorkOrderList() {
            this.loading = true
            workOrderList({
                order_id: this.orderDetailsData.order_id,
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
            }).then(res => {
                if (res.code === 200) {
                    this.workOrderList = this.workOrderList.concat(res.data.data)
                }
                this.loading = false
            })
        },

        //滚动加载工单管理列表
        scrollLoadWorkOrderList() {
            if (this.workOrderList.length < this.pagination.total) {
                this.pagination.pageNum++
                this.getWorkOrderList()
            }
        },

        //获取售后记录列表
        getAfterSaleList() {
            this.loading = true
            orderAfterSaleList({
                order_id: this.orderDetailsData.order_id
            }).then(res => {
                if (res.code === 200) {
                    res.data.forEach(item => {
                        switch (item.approval_status) {
                            case 0:
                                item.approval_status_name = '审批中'
                                break
                            case 1:
                                item.approval_status_name = '已通过'
                                break
                            case 2:
                                item.approval_status_name = '已拒绝'
                                break
                            case 3:
                                item.approval_status_name = '已撤销'
                                break
                        }
                    })
                    this.afterSaleList = res.data
                }
                this.loading = false
            })
        },

        //售后记录撤销
        handleClickAfterSaleRevoke(row) {
            this.$dialog.confirm({
                title: '撤销',
                message: '是否撤销该售后操作?',
                confirmButtonColor: '#2990ff'
            }).then(() => {
                cancelApproval({
                    approval_id: row.approval_id
                }).then(res => {
                    if (res.code === 200) {
                        this.$toast.success('撤销成功！')
                        this.getAfterSaleList()
                    }
                })
            }).catch(() => {
            })
        },

        //售后记录详情
        handleClickAfterSaleDetail(row) {
            this.after_sale_type = row.type
            this.after_sale_type_name = row.type_name
            orderAfterSaleDetail({
                type: row.type,
                relate_id: row.relate_id,
            }).then(res => {
                if (res.code === 200) {
                    this.orderAfterSaleDetailData = res.data
                    this.orderAfterSaleDetailDialog = true
                }
            })
        },

        //获取团队成员列表
        getTeamMemberList() {
            this.loading = true
            orderMemberList({
                order_id: this.orderDetailsData.order_id
            }).then(res => {
                if (res.code === 200) {
                    this.teamMemberList = res.data
                }
                this.loading = false
            })
        },

        //添加成员
        handleClickAddMember() {
            this.teamMembersAddVisible = true
        },

        //团队成员权限切换
        handleOrderMemberAuthChange: throttle(function (row) {
            orderMemberAuthEdit({
                order_id: this.orderDetailsData.order_id,
                member_uid: row.member_uid,
                auth: row.auth
            }).then(res => {
                if (res.code === 200) {
                    this.$toast.success('修改成功');
                    this.getTeamMemberList();
                }
            });
        }, 2000), // 设置节流间隔为 2000 毫秒（2秒）

        //移除成员
        handleClickRemoveMember(row) {
            orderMemberDel({
                order_id: this.orderDetailsData.order_id,
                member_uid: row.member_uid
            }).then(res => {
                if (res.code === 200) {
                    this.$toast.success('移除成功');
                    this.getTeamMemberList();
                }
            })
        },

        //获取订单日志列表
        getOrderLogList() {
            this.laoding = true
            orderLogList({
                order_id: this.orderDetailsData.order_id
            }).then(res => {
                if (res.code === 200) {
                    this.orderLogList = res.data.data
                    this.laoding = false
                }
            })
        },

        refreshDetail() {
            this.getOrderDetail()
            this.eventBusOrderList()
        },

        eventBusOrderList() {
            EventBus.$emit('orderUpdated');
        },

    },
}
</script>
<style lang="scss" scoped>
.order_info_wrap {
    padding: 12px 16px;
    border-bottom: 1px solid #E8E8E8;

    .order_num {
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        color: #333333;
    }

    .line {
        margin: 0 4px;
    }

    .company_name, .create_date {
        color: #666666;
    }
}

::v-deep .van-tabs {
    flex: 1;
    max-height: calc(100% - 127px);

    .van-tab {
        font-size: 16px;

        &.van-tab--active {
            font-weight: 700;
        }
    }

    .van-tabs__content {
        width: 100%;
        height: calc(100% - 44px);

        .van-tab__pane {
            width: 100%;
            height: 100%;
        }
    }

    .van-tabs__line {
        width: 60px;
    }
}

.detail_tab_content {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding: 16px;
    background-color: #FFFFFF;
}

.tab_list_wrap {
    width: 100%;
    height: 100%;
    background: #F7F8FA;

    &.white {
        background: #FFFFFF;
    }

    .order_records_list {
        height: 100%;
        overflow-y: auto;
        border-top: 1px solid #E8E8E8;

        &.brief {
            height: calc(100% - 211px);
            border-top: none;
        }

        .order_records_item {
            padding: 12px 16px;
            background: #FFFFFF;
            margin-bottom: 4px;

            .order_records_heade {
                border-bottom: 1px solid #E8E8E8;
                padding-bottom: 8px;
                display: flex;
                justify-content: space-between;

                .link-label {
                    font-weight: bold;
                }

                .status_name {
                    color: #666666;
                    vertical-align: middle;
                    margin-left: 4px;

                    &::before {
                        content: '';
                        width: 6px;
                        height: 6px;
                        border-radius: 50%;
                        display: inline-block;
                        vertical-align: middle;
                        margin-right: 4px;
                    }

                    &.status_name_1::before {
                        background: #F0AA32;
                    }

                    &.status_name_2::before {
                        background: #5AB333;
                    }

                    &.status_name_3::before {
                        background: #E44144;
                    }

                    &.status_name_4::before {
                        background: #F0AA32;
                    }

                    &.invoice_status_name_1::before {
                        background: #F0AA32;
                    }

                    &.invoice_status_name_2::before {
                        background: #5AB333;
                    }

                    &.invoice_status_name_3::before {
                        background: #E44144;
                    }

                    &.invoice_status_name_4::before {
                        background: #E44144;
                    }

                    &.invoice_status_name_5::before {
                        background: #BFBFBF;
                    }

                    &.payment_status_name_1::before {
                        background: #F0AA32;
                    }

                    &.payment_status_name_2::before {
                        background: #5AB333;
                    }

                    &.payment_status_name_3::before {
                        background: #E44144;
                    }

                    &.payment_status_name_4::before {
                        background: #BFBFBF;
                    }

                    &.payment_status_name_5::before {
                        background: #E44144;
                    }

                    &.approval_status_0::before {
                        background: #F0AA32;
                    }

                    &.approval_status_1::before {
                        background: #5AB333;
                    }

                    &.approval_status_2::before {
                        background: #E44144;
                    }

                    &.approval_status_3::before {
                        background: #BFBFBF;
                    }
                }
            }

            .order_records_content {
                padding-top: 10px;

                .field_label {
                    color: #999999;
                }

                .field_value {
                    color: #333333;
                }
            }
        }
    }

    .team_member_list {
        .team_member_item {
            padding: 12px 16px;
            border-bottom: 1px solid #E8E8E8;
        }
    }
}

.page_little_title {
    margin-bottom: 0;
}

.payments_overview_wrap {
    padding: 16px;
    background: #FFFFFF;
    border-top: 1px solid #E8E8E8;
    margin-bottom: 4px;

    .payments_chart_wrap {
        gap: 16px;

        .left_progress_wrap {
            width: 140px;
            height: 140px;
            position: relative;

            .center_repay_price_wrap {
                width: 150px;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                text-align: center;

                .label {
                    font-size: 12px;
                    color: #999999;
                    line-height: 18px;
                }

                .amount {
                    font-size: 14px;
                    font-weight: 700;
                    line-height: 24px;
                    color: #333333;
                }

                .ratio {
                    font-size: 12px;
                    color: #666666;
                    line-height: 18px;
                }
            }

            ::v-deep .el-progress__text {
                display: none;
            }

            .no_repay_ratio_progress, .total_refund_ratio_progress, .repayment_ratio_progress {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }
        }

        .right_amount_wrap {
            flex: 1;

            .amount_item_wrap {
                display: flex;
                align-items: center;
                justify-content: space-between;
                line-height: 22px;
                margin-bottom: 8px;

                .amount_label {
                    color: #666666;

                    &::before {
                        content: '';
                        display: inline-block;
                        width: 6px;
                        height: 6px;
                        border-radius: 50%;
                        margin-right: 4px;
                        vertical-align: middle;
                    }

                    &.amount_label_1::before {
                        background-color: #F0AA32;
                    }

                    &.amount_label_2::before {
                        background-color: #E44144;
                    }

                    &.amount_label_3::before {
                        background-color: #5AB333;
                    }

                    &.amount_label_4::before {
                        background-color: #2990FF;
                    }
                }

                .amount_value {
                    color: #333333;
                    font-weight: bold;
                    vertical-align: middle;
                }
            }
        }
    }
}

.invoice_overview_wrap {
    flex: 0.5;
    background-color: #FFFFFF;
    border-radius: 6px;
    padding: 16px 16px 0;
    border-top: 1px solid #E8E8E8;

    .invoice_overview_board {
        margin-bottom: 4px;

        .percentage_wrap {
            gap: 60px;
            padding: 16px 0 12px;
            position: relative;

            .progress_text {
                position: absolute;
                left: 25px;
                text-align: center;
                background-color: #FFFFFF;
                width: 75px;

                .percentage {
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 24px;
                    color: #2990FF;
                }

                .text {
                    font-size: 12px;
                    line-height: 18px;
                    color: #999999;
                }
            }
        }

        .amount_wrap {
            flex: 1;

            .amount_label {
                line-height: 22px;
                color: #666666;
            }

            .amount_value {
                font-weight: 700;
                line-height: 22px;
                color: #333333;
            }
        }
    }
}

.order_log_list {
    padding: 16px;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    background-color: #FFFFFF;

    .order_log_item {
        padding-left: 20px;
        margin-bottom: 16px;
        border-left: 1px dashed #E8E8E8;
        position: relative;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: -8px;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            border: 4px solid #2990FF;
            background-color: #FFFFFF;
            box-sizing: content-box;
        }

        .created_at {
            font-size: 12px;
            line-height: 22px;
            color: #666666;
            margin-left: 4px;
        }

        .log_content_wrap {
            border-radius: 6px;
            background: #EDF0F4;
            padding: 8px 12px;
            margin-top: 8px;

            .log_content {
                color: #666666;
                line-height: 22px;
            }

            .order_edit_content {
                padding: 12px;
                background-color: #FFFFFF;
                border-radius: 6px;
                margin-top: 8px;
            }
        }
    }
}
</style>